export const RESUME_SECTION_TYPES = {
  PERSONAL_INFO: "personalInfo",
  SUMMARY: "summary",
  EXPERIENCE: "experience",
  EDUCATION: "education",
  SKILLS: "skills",
  PROJECTS: "projects",
  CERTIFICATIONS: "certifications",
  LANGUAGES: "languages",
  AWARDS: "awards",
  ACHIEVEMENTS: "achievements",
  PUBLICATIONS: "publications",
  VOLUNTEER: "volunteer",
  COURSEWORK: "coursework",
  INTERESTS: "interests",
  REFERENCES: "references",
  MEMBERSHIPS: "memberships",
  SPEAKING: "speaking",
  PATENTS: "patents",
  SPACER: "spacer",
};

export const RESUME_SECTION_OPTIONS = [
  { label: "Personal Info", value: RESUME_SECTION_TYPES.PERSONAL_INFO },
  { label: "Summary", value: RESUME_SECTION_TYPES.SUMMARY },
  { label: "Experience", value: RESUME_SECTION_TYPES.EXPERIENCE },
  { label: "Education", value: RESUME_SECTION_TYPES.EDUCATION },
  { label: "Skills", value: RESUME_SECTION_TYPES.SKILLS },
  { label: "Projects", value: RESUME_SECTION_TYPES.PROJECTS },
  { label: "Certifications", value: RESUME_SECTION_TYPES.CERTIFICATIONS },
  { label: "Languages", value: RESUME_SECTION_TYPES.LANGUAGES },
  { label: "Achievements", value: RESUME_SECTION_TYPES.ACHIEVEMENTS },
  { label: "Interests", value: RESUME_SECTION_TYPES.INTERESTS },
  { label: "Spacer (vertical gap)", value: RESUME_SECTION_TYPES.SPACER },

  // { label: "Awards", value: RESUME_SECTION_TYPES.AWARDS },
  // { label: "Publications", value: RESUME_SECTION_TYPES.PUBLICATIONS },
  // { label: "Volunteer Experience", value: RESUME_SECTION_TYPES.VOLUNTEER },
  // { label: "Coursework", value: RESUME_SECTION_TYPES.COURSEWORK },
  // { label: "References", value: RESUME_SECTION_TYPES.REFERENCES },
  // { label: "Speaking & Conferences", value: RESUME_SECTION_TYPES.SPEAKING },
  // { label: "Patents", value: RESUME_SECTION_TYPES.PATENTS },
  // { label: "Professional Memberships", value: RESUME_SECTION_TYPES.MEMBERSHIPS },
];

export const REQUIRED_TYPES = [
  // RESUME_SECTION_TYPES.PERSONAL_INFO,
  // RESUME_SECTION_TYPES.SUMMARY,
  // RESUME_SECTION_TYPES.EXPERIENCE,
];

export const SECTION_STABLE_KEYS = {
  [RESUME_SECTION_TYPES.PERSONAL_INFO]: "personalInfo",
  [RESUME_SECTION_TYPES.SUMMARY]: "professionalSummary",
  [RESUME_SECTION_TYPES.EXPERIENCE]: "experiences",
  [RESUME_SECTION_TYPES.EDUCATION]: "educations",
  [RESUME_SECTION_TYPES.SKILLS]: "skills",
  [RESUME_SECTION_TYPES.PROJECTS]: "projects",
  [RESUME_SECTION_TYPES.CERTIFICATIONS]: "certifications",
  [RESUME_SECTION_TYPES.LANGUAGES]: "languages",
  [RESUME_SECTION_TYPES.AWARDS]: "awards",
  [RESUME_SECTION_TYPES.ACHIEVEMENTS]: "achievements",
  [RESUME_SECTION_TYPES.PUBLICATIONS]: "publications",
  [RESUME_SECTION_TYPES.VOLUNTEER]: "volunteer",
  [RESUME_SECTION_TYPES.COURSEWORK]: "coursework",
  [RESUME_SECTION_TYPES.INTERESTS]: "interests",
  [RESUME_SECTION_TYPES.REFERENCES]: "references",
  [RESUME_SECTION_TYPES.MEMBERSHIPS]: "memberships",
  [RESUME_SECTION_TYPES.SPEAKING]: "speaking",
  [RESUME_SECTION_TYPES.PATENTS]: "patents",
};

export const SECTION_META = {
  [RESUME_SECTION_TYPES.PERSONAL_INFO]: {
    title: "Personal Info",
    subtitle: "Identity, contact, and authorization details",
  },
  [RESUME_SECTION_TYPES.SUMMARY]: {
    title: "Summary",
    subtitle: "A brief professional overview",
  },
  [RESUME_SECTION_TYPES.EXPERIENCE]: {
    title: "Experience",
    subtitle: "Work history, including internships and articleships",
  },
  [RESUME_SECTION_TYPES.EDUCATION]: {
    title: "Education",
    subtitle: "Schools, degrees, coursework, honors, activities",
  },
  [RESUME_SECTION_TYPES.SKILLS]: {
    title: "Skills",
    subtitle: "Hard and soft skills",
  },
  [RESUME_SECTION_TYPES.PROJECTS]: {
    title: "Projects",
    subtitle: "Notable projects you've built or led",
  },
  [RESUME_SECTION_TYPES.CERTIFICATIONS]: {
    title: "Certifications",
    subtitle: "Professional certifications and licenses",
  },
  [RESUME_SECTION_TYPES.LANGUAGES]: {
    title: "Languages",
    subtitle: "Languages you speak and proficiency",
  },
  [RESUME_SECTION_TYPES.AWARDS]: {
    title: "Awards",
    subtitle: "Formal recognitions and honors",
  },
  [RESUME_SECTION_TYPES.ACHIEVEMENTS]: {
    title: "Achievements",
    subtitle: "Quantified wins, competitions, ranks, milestones",
  },
  [RESUME_SECTION_TYPES.PUBLICATIONS]: {
    title: "Publications",
    subtitle: "Papers, articles, journals, books",
  },
  [RESUME_SECTION_TYPES.VOLUNTEER]: {
    title: "Volunteer Experience",
    subtitle: "Community service and pro-bono work",
  },
  [RESUME_SECTION_TYPES.COURSEWORK]: {
    title: "Coursework",
    subtitle: "Relevant courses and training",
  },
  [RESUME_SECTION_TYPES.INTERESTS]: {
    title: "Interests",
    subtitle: "Hobbies and personal interests",
  },
  [RESUME_SECTION_TYPES.REFERENCES]: {
    title: "References",
    subtitle: "Professional references or availability note",
  },
  [RESUME_SECTION_TYPES.MEMBERSHIPS]: {
    title: "Professional Memberships",
    subtitle: "ICAI, IEEE, PMI, bar association, etc.",
  },
  [RESUME_SECTION_TYPES.SPEAKING]: {
    title: "Speaking & Conferences",
    subtitle: "Talks, panels, workshops you've delivered",
  },
  [RESUME_SECTION_TYPES.PATENTS]: {
    title: "Patents",
    subtitle: "Filed or granted patents",
  },
  [RESUME_SECTION_TYPES.SPACER]: {
    title: "Spacer",
    subtitle: "Adjustable vertical whitespace in the resume",
  },
};

// Default spacer height in PDF points. 1 pt ≈ 0.353 mm ≈ 1.333 px.
export const SPACER_DEFAULT_SIZE = 12;
export const SPACER_MIN = 0;
export const SPACER_MAX = 72;

export const FLUENCY_OPTIONS = ["Native", "Fluent", "Conversational", "Basic"];

export const EMPLOYMENT_TYPE_OPTIONS = [
  "Full-time",
  "Part-time",
  "Contract",
  "Internship",
  "Articleship",
  "Freelance",
  "Apprenticeship",
];

export const PATENT_STATUS_OPTIONS = [
  "Granted",
  "Filed",
  "Pending",
  "Published",
];

export const REFERENCE_MODE = {
  AVAILABLE_ON_REQUEST: "on_request",
  LIST: "list",
};
